import { CompanyType } from '@/interfaces/company'

// Map OrderReceiptStatus to Spanish labels
export const COMPANY_TYPE_LABELS: Record<CompanyType, string> = {
  PROVIDER: 'Proveedor',
  IMPORTER: 'Importadora',
  TRANSPORTER: 'Transportista',
  MANAGER: 'Operador logistico ',
  STORAGE: 'Operador de almacenes',
}

// Generate status options for order status
export const companyTypeOptions = [
  { value: 'all', label: 'Todos' },
  ...Object.entries(COMPANY_TYPE_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
]

// Type for status option
export interface StatusOption {
  value: string
  label: string
}
